import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css'],
})
export class ConfirmationDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() useDialog: boolean;
  @Output() confirmed = new EventEmitter<Boolean>();
  @Output() cancelled = new EventEmitter<Boolean>();

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {}

  confirm() {
    this.confirmed.emit(true);

    this.closeDialog(true);
  }
  cancel() {
    this.cancelled.emit(false);
    this.closeDialog(false);
  }
  private closeDialog(response: boolean) {
    if (this.useDialog) {
      this.dialogRef.close(response);
    }
  }

  ngOnInit(): void {}
}
